// Trasy dwujęzyczne PL/EN — klucz camelCase -> ścieżki (wzorzec ROUTE_MAP z mpracownika).
export const ROUTE_MAP = {
    login: { en: "/login", pl: "/logowanie" },
    dashboard: { en: "/dashboard", pl: "/pulpit" },
    passes: { en: "/passes", pl: "/przepustki" },
    guard: { en: "/verification", pl: "/weryfikacja" },
    cards: { en: "/cards", pl: "/karty" },
    // Wystawianie przepustek PRACOWNIKOM — pojedynczo i masowo, przez Biuro Przepustek.
    employeePasses: { en: "/employee-passes", pl: "/przepustki-pracownikow" },
    // Panel administratora — jedno wejście do wszystkich modułów konfiguracyjnych.
    // Adres jest wspólny dla obu języków: to katalog nadrzędny nad /admin/*.
    adminPanel: { en: "/admin", pl: "/admin" },
    adminUsers: { en: "/admin/users", pl: "/admin/uzytkownicy" },
    // Grupy uprawnień (rangi) — zestawy kluczy nadawane wielu kontom naraz. Osobny ekran od
    // kont: tam nadaje się dodatki i odjęcia POJEDYNCZEJ osobie, tu zmienia się zakres
    // całej rangi, więc jedno kliknięcie działa na wszystkich jej członków.
    adminAccessGroups: { en: "/admin/access-groups", pl: "/admin/grupy-uprawnien" },
    adminWhitelist: { en: "/admin/whitelist", pl: "/admin/whitelista" },
    adminLoginHistory: { en: "/admin/login-history", pl: "/admin/historia-logowan" },
    // Dziennik dostępu do danych wrażliwych — osobny ekran od historii logowań: tamta mówi,
    // KTO wszedł do systemu, ten — CO w nim zobaczył (wymóg klienta 2026-08-09).
    adminDataAccess: { en: "/admin/data-access", pl: "/admin/dziennik-dostepu" },
    adminZones: { en: "/admin/zones", pl: "/admin/strefy" },
    // Firmy zewnętrzne z własnym panelem — konta przedstawicieli i kartoteki pracowników
    // firmy zakłada się w tym module, a firma pracuje potem na trasie `company`.
    adminCompanies: { en: "/admin/companies", pl: "/admin/firmy" },
    adminO365: { en: "/admin/o365-configuration", pl: "/admin/konfiguracja-o365" },
    // Parametry PROCESU (okna weryfikacji, karencja PDF) — osobno od konfiguracji O365,
    // która dotyczy logowania i jest pod `adminO365`.
    adminSettings: { en: "/admin/settings", pl: "/admin/ustawienia" },
    // Treści SMS-ów i e-maili wysyłanych przez system — edytowalne bez wdrożenia.
    adminMessages: { en: "/admin/messages", pl: "/admin/wiadomosci" },
    // Kartoteka wizytatorów (dawniej „Konta przepustek") — zakładka CODZIENNEJ pracy obsługi,
    // nie moduł administracyjny (decyzja klienta 2026-08-07): bez /admin i bez PIN-u.
    // ADRES ZOSTAJE stary mimo zmiany nazwy (2026-08-09): pracownicy mają go w zakładkach
    // przeglądarki i w linkach, a zmiana ścieżki zerwałaby je bez żadnego zysku.
    portalAccounts: { en: "/portal-accounts", pl: "/konta-przepustek" },
    // Kartoteki firm zewnętrznych OCZAMI PRACOWNIKA KG — moduł codziennej pracy, nie panel
    // administratora: pracownik sprawdza, kto należy do firmy i jakie ma przepustki, ale
    // niczego nie zakłada ani nie zmienia (od tego jest `adminCompanies` pod PIN-em).
    // Adres celowo blisko panelu firmy (/firma vs /firmy) — to ta sama dziedzina, inna rola.
    companies: { en: "/companies", pl: "/firmy" },
    // Panel firmy zewnętrznej — firma SAMA prowadzi kartoteki swoich pracowników
    // i wnioskuje o przepustki w ich imieniu. Wejścia nie pilnuje klucz PERM, tylko
    // powiązanie konta z firmą (user.companyId) — patrz trasa w App.js.
    company: { en: "/company", pl: "/firma" },
    // Stary adres modułu (żył w panelu administratora) — zostaje WYŁĄCZNIE jako przekierowanie,
    // żeby zapisane linki i zakładki przeglądarek nie prowadziły w pustkę.
    adminPortalAccounts: { en: "/admin/portal-accounts", pl: "/admin/konta-przepustek" },
};

/**
 * Ścieżka linku zaszytego w KODZIE QR przepustki (`/weryfikacja/<token>`).
 *
 * CELOWO poza ROUTE_MAP: adres trafia na wydruk PDF i do kodu QR na telefonie gościa, więc musi
 * być JEDEN i niezmienny — nie może zależeć od języka interfejsu osoby, która skanuje (ROUTE_MAP
 * rozstrzyga język z localStorage skanującego, a ten bywa inny niż w chwili wystawienia kodu).
 * Wariant angielski jest rejestrowany w App.js wyłącznie jako alias dla starszych/ręcznych linków.
 *
 * LUSTRO stałej PassPdfService.VerificationPath po stronie serwera — obie muszą się zgadzać.
 */
export const PASS_VERIFY_PATH = "/weryfikacja";
export const PASS_VERIFY_PATH_EN = "/verification";
